// extracted by mini-css-extract-plugin
export var answerGroup = "faq-module--answerGroup--eacc6";
export var backBtn = "faq-module--backBtn--ec700";
export var categories = "faq-module--categories--1d156";
export var container = "faq-module--container--56f17";
export var controls = "faq-module--controls--3fc8e";
export var noResults = "faq-module--noResults--eced3";
export var search = "faq-module--search--895c4";
export var searchInput = "faq-module--searchInput--d7bfc";
export var section = "faq-module--section--2fd24";
export var text = "faq-module--text--e9cc7";
export var title = "faq-module--title--6c0ae";
export var topSection = "faq-module--topSection--79afe";